// extracted by mini-css-extract-plugin
export var focus = "SearchBar-module--focus--hMt3M";
export var searchbar = "SearchBar-module--searchbar--aKSKX";